// PRC EDITED: dynamic free shipping message (estimate 4093671, line 3).
// Re-renders every [data-prc-free-shipping] element (snippets/prc-free-shipping.liquid)
// when Dawn publishes PUB_SUB_EVENTS.cartUpdate. Loaded after pubsub.js.
(() => {
  const SELECTOR = '[data-prc-free-shipping]';

  function formatAmount(cents, decimals, thousands = ',', decimal = '.') {
    const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  }

  function formatMoney(cents, format) {
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return formatAmount(cents, 0);
        case 'amount_with_comma_separator':
          return formatAmount(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatAmount(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatAmount(cents, 2, "'", '.');
        default:
          return formatAmount(cents, 2);
      }
    });
  }

  function render(totalPrice) {
    document.querySelectorAll(SELECTOR).forEach((element) => {
      const remaining = Number(element.dataset.threshold) - totalPrice;
      element.textContent =
        remaining > 0
          ? element.dataset.addMessage.replace('[total]', formatMoney(remaining, element.dataset.moneyFormat))
          : element.dataset.successMessage;
    });
  }

  function refresh(cartData) {
    if (!document.querySelector(SELECTOR)) return;

    // Cart-change responses carry the whole cart; product-form responses carry only the added item.
    if (cartData && typeof cartData.total_price === 'number' && 'item_count' in cartData) {
      render(cartData.total_price);
      return;
    }

    return fetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => render(cart.total_price))
      .catch((e) => console.error(e));
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refresh(event?.cartData));

  // Back/forward cache restores a page with a stale cart total.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
})();
